import { AppConfig } from "@/common/appConfig";
import { PlanName } from "@/common/enums/enums";
import { useAuthStore } from "@/store/auth.store";
import { redirect } from "@tanstack/react-router";

export const protectedNoFreeRoute = (): void | ReturnType<typeof redirect> => {
  const { userData } = useAuthStore.getState();
  if (AppConfig.disablePremiumRestrictions) {
    return undefined;
  }
  if (!userData || userData.planName === PlanName.FREE_TRIAL) {
    return redirect({ to: "/" });
  }

  return undefined;
};
